import { module } from 'modujs';
import { html } from '../utils/environment';
import { gsap } from 'gsap';

export default class extends module {
    constructor(m) {
        super(m);

        this.events = {
            click: 'click'
        }
    }

    init() {

    }

    click() {
        html.classList.add('has-menu-transition');

        if(html.classList.contains('has-menu-open')) {
            html.classList.add('has-menu-closing');
        }

        gsap.delayedCall(1.2, () => {
            html.classList.remove('has-menu-transition');
            html.classList.remove('has-menu-closing');
        });

        html.classList.toggle('has-menu-open');
    }
}
